import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="section-y">
      <div className="container-x text-center">
        <span className="label-eyebrow">— Error 404</span>
        <h1 className="mt-4 text-5xl sm:text-7xl font-heading font-bold">Page not found</h1>
        <p className="mt-4 text-ink/65">The page you're looking for doesn't exist.</p>
        <Link to="/" data-testid="back-home-btn" className="mt-8 btn-primary inline-flex">Back to home</Link>
      </div>
    </section>
  );
}
